module.exports = __webpack_public_path__ + "static/media/codeblockLogo.31fb8d66.png";